import * as HLF from "html-living-framework";
import {Application} from "../Application";
import {Callback} from "../core/Reflection";
import {StoryInjection} from "../data/StoryModel";
import {VoiceOverManager} from "../managers/VoiceOverManager";
import {StoryCreator} from "../states/StoryCreator";

export class SceneInjectionPlayVO implements StoryInjection {

    private assets?: Array<HLF.IAsset<any>>;
    private readonly vo: string | string[];

    constructor(vo: string | string[]) {
        this.vo = vo;
    }

    public execute(storyCreator: StoryCreator, cb: Callback): void {
        if (Application.instance.audio.masterVolume === 0) {
            cb();
            return;
        }
        VoiceOverManager.instance.playVO(this.vo, cb);
    }

    public getAssets(): Array<HLF.IAsset<any>> {
        if (!this.assets) {
            this.assets = ((typeof this.vo === "string") ? [this.vo] : this.vo).map((it) => new HLF.AudioAsset(it, HLF.AudioCategory.VO));
        }
        return this.assets;
    }
}
